import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import "./PostAssetMenu.scss";
import toast from "react-hot-toast";
import { Modal } from "@mui/material";
import SubMenuThreeDotIcon from "../../../../../components/icons/SubMenuThreeDotIcon";

const PostAssetMenu = ({
  onUpdate,
  onPreview,
  previewImageUrl,
  templateRelativePath, // <-- 1. Add new prop here
}: {
  onUpdate?: () => void;
  onPreview?: () => void;
  previewImageUrl?: string;
  templateRelativePath?: string; // <-- 1. And define its type
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // This function remains the same, for downloading the JPG/PNG preview
  const downloadImagePreview = (imageUrl: string) => {
    if (!imageUrl) return;

    // This logic is specific to extracting the path from the full image URL
    const relativePath = imageUrl.replace(/^.*\/design-tool\/images\//, "");
    const downloadUrl = `https://designtoolapi.share.zrok.io/api/design-tool/download-image?asset_path=${relativePath}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute(
      "download",
      relativePath.split("/").pop() || "preview.jpg"
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // --- START OF NEW CODE ---
  // 2. Create a new function specifically for downloading the template file
  const downloadTemplateFile = (relativePath: string) => {
    if (!relativePath || relativePath === "N/A") {
      toast.error("Template file path is not available.");
      return;
    }
    // We use the relative path directly
    const downloadUrl = `https://designtoolapi.share.zrok.io/api/design-tool/download-image?asset_path=${relativePath}`;
    
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute(
      "download",
      relativePath.split("/").pop() || "template.ai" // Set a default name
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // --- END OF NEW CODE ---

  return (
    <>
      <div
        className="all-menu-icon"
        onClick={handleClick}
        // ... (rest of the attributes)
      >
        {isLoading ? (
          <CircularProgress
            className="circular-progress-action-icon"
            style={{ width: 15, height: 15 }}
          />
        ) : (
          <SubMenuThreeDotIcon />
        )}
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // ... (rest of the props)
      >
        <MenuItem
          onClick={() => {
            onPreview?.();
            handleClose();
          }}
        >
          Preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            onUpdate?.();
            handleClose();
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (previewImageUrl) {
              downloadImagePreview(previewImageUrl);
            }
            handleClose();
          }}
        >
          Download Preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (templateRelativePath) {
              downloadTemplateFile(templateRelativePath);
            }
            handleClose();
          }}
        >
          Download Template File
        </MenuItem>
      </Menu>
    </>
  );
};

export default PostAssetMenu;